import StatisticBlockItem from '@/components/StatisticBlockItem/StatisticBlockItem';
export default StatisticBlockItem;
